import { cn } from '@repo/ui/lib/utils'
import { cva, VariantProps } from 'class-variance-authority'
import { ComponentPropsWithoutRef } from 'react'

const textareaVariants = cva('placeholder:text-muted flex w-full py-3 text-base disabled:cursor-not-allowed disabled:opacity-50', {
  variants: {
    variant: {
      default: 'focus-visible:miista-focus rounded-lg border border-solid border-current px-3',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

function TextArea({ className, variant, ...props }: ComponentPropsWithoutRef<'textarea'> & VariantProps<typeof textareaVariants>) {
  return <textarea data-slot='textarea' className={cn(textareaVariants({ variant }), className)} {...props} />
}

export { TextArea }
